<template>
    <v-card-text class="pa-3">
        <div class="text-center">
            <h4 class="title font-weight-bold primary--text mb-5">
                Account Registration
            </h4>
        </div>

        <v-form
            class="text-center"
            validate-on-blur
            @submit.prevent="proceed"
        >
            <template v-for="field in fields">
                <v-autocomplete
                    v-if="field.type === 'select'"
                    :key="`select_${field.name}`"
                    v-validate="getRules(field)"
                    v-model="values[field.name]"
                    :label="field.label"
                    :name="field.name"
                    :items="field.options"
                    item-text="label"
                    item-value="value"
                    item-color="primary"
                    color="primary"
                    background-color="#f8f8fd"
                    outlined
                    :error-messages="errors.first(field.name)"
                />

                <date-picker
                    v-else-if="field.type === 'date'"
                    :key="`date_${field.name}`"
                    v-validate="getRules(field)"
                    v-model="values[field.name]"
                    :minDate="field.rules ? new Date(field.rules.minDate) : null"
                    :name="field.name"
                    :label="field.label"
                    :error-messages="errors.first(field.name)"
                />

                <v-text-field
                    v-else-if="field.type === 'phone'"
                    :key="`phone_${field.name}`"
                    v-validate="getRules(field)"
                    v-model="values[field.name]"
                    type="text"
                    :label="field.label"
                    :name="field.name"
                    background-color="#f8f8fd"
                    color="primary"
                    outlined
                    hint="Enter phone number starting with country code e.g. +1, +234, +44, etc."
                    :error-messages="errors.first(field.name)"
                />

                <v-radio-group
                    v-else-if="field.type === 'radio'"
                    :key="`radio_${field.name}`"
                    v-model="values[field.name]"
                    :label="field.label"
                    :name="field.name"
                >
                    <v-radio
                        v-for="item in field.options"
                        :key="`radio_${field.name}_${item.value}`"
                        :label="item.label"
                        :value="item.value"
                    ></v-radio>
                </v-radio-group>

                <v-text-field
                    v-else
                    :key="field.name"
                    v-validate="getRules(field)"
                    type="text"
                    :label="field.label"
                    :name="field.name"
                    background-color="#f8f8fd"
                    color="primary"
                    :hint="field.description"
                    v-model="values[field.name]"
                    validate-on-blur
                    outlined
                    :error-messages="errors.first(field.name)"
                />
            </template>

            <div class="text-center my-4">
                <v-btn
                    class="text--white text-capitalize py-5 title"
                    color="primary"
                    dark
                    block
                    elevation="2"
                    depressed
                    @click.prevent="proceed"
                >
                    Continue
                </v-btn>
                <v-btn
                    class="primary--text text-capitalize py-5 mt-3"
                    dark
                    @click.prevent="cancel"
                    text
                >
                    Cancel
                </v-btn>
            </div>
        </v-form>
    </v-card-text>
</template>

<script>
import DatePicker from '../date-picker.vue';

export default {
    props: {
        fields: Array,
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            values: {},
        };
    },
    methods: {
        getRules: ({ rules }) => {
            let rulesArray = [
                'required',
            ];

            if (rules) {
                if (rules.regex) {
                    rulesArray.push(`regex:${rules.regex}`);
                }

                if (rules.minLength) {
                 rulesArray.push(`min:${rules.minLength}`);
                }

                if (rules.maxLength) {
                    rulesArray.push(`max:${rules.maxLength}`);
                }
            }

            return rulesArray.join('|');
        },
        isVisible(visibilityDependsOn) {
            if(!visibilityDependsOn) {
                return true;
            }

            const {
                fieldId,
                values,
            } = visibilityDependsOn;

            if (!this.values[fieldId]) {
                return false;
            }

            const value = this.values[fieldId].toLowerCase();
            return !!values.find((v) => value === v.toLowerCase());
        },
        proceed() {
            this.$validator.validateAll().then((formIsValid) => {
                if (formIsValid) {
                    this.$emit('proceed', this.values);
                }
            });
        },
        cancel() {
            this.$emit('cancel');
        }
    },
}
</script>
